

//const envision="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/news_img/envision_2024.webp"
const sih = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/news_img/sih.webp";
const project_demo = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/news_img/project_demo_build.webp"
const oracle = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/news_img/oracle.webp"
const edc = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/about/home/news_img/edc.webp"
const ga = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/about/home/news_img/ga.webp"
const nlp = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/about/home/news_img/nlp.webp"
const stnd_day = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/about/home/news_img/stnd_day.webp"
const ececover = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Ece/microchip.webp"
const nba_visit = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/about/home/news_img/NBA_visit.webp"
const build_workshop = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/about/home/news_img/Build_workshop.webp"
const conference_iitmrp = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/about/home/news_img/Conference_iitmrp.webp"
const Nexora_pic = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/about/home/news_img/nexora.webp"
const iste_inauguration = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/news_img/ISTE_INAUGURATION.webp"
const framing_workshop = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/iqac/FRAME_ANALYTICAL_QUESTION.webp"
const startup_meetup = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/news_img/forum.webp"
const career_guidance = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/iqac/Career+Guidance_1.webp"
const motivation_session = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/iqac/Motivation+session_1.webp"
const nba = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/iqac/ECE+NBA-1.webp"
const naan_mudhalvan = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/iqac/Naan+mudhalvan-1.webp"
const pongal = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/iqac/Pongal-1.webp"
const  laptop = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/iqac/Laptop-1.webp"
const iste_3d="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/news_img/iste+3d+.webp"
export const news_info = [
    {
         'id':'1',
         'heading':"Career Guidance -Study Abroad Opportunities Seminar",
         'sub-head':' Dr. X. Hyacinth Suganthi, Placement Coordinator, at Sangamam Hall.',
         'pic':career_guidance,
         'content_1':'',
         'content_2':'',
         'butt_text':'viewpdf',
         'pdflink':'https://drive.google.com/file/d/12cYqj5LBvTHLfOrx6ylsjZLuMiB7x606/view?usp=sharing',

     },
      {
         'id':'2',
         'heading':"The Power of Time Management”-Motivation session",
         'sub-head':'Miss.P.Sezhina Kanakambika (ASP), ECE Dept.',
         'pic':motivation_session,
         'content_1':'',
         'content_2':'',
         'butt_text':'viewpdf',
         'pdflink':'https://drive.google.com/file/d/1XW3klmAVzwW7uvkF6v64WUUeTFnyhFTL/view?usp=sharing',

     },
     {
         'id':'3',
         'heading':"NBA Visit - ECE Dept",
         'sub-head':'The Department of ECE successfully hosted the National Board of Accreditation (NBA) visit as part of the accreditation process.',
         'pic':nba,
         'content_1':'',
         'content_2':'',
        // 'butt_text':'viewpdf',
        // 'pdflink':'https://drive.google.com/file/d/1XW3klmAVzwW7uvkF6v64WUUeTFnyhFTL/view?usp=sharing',

     },
     {
         'id':'4',
         'heading':"Naan Mudhalvan Tamil Nadu State Level Placement Program(TNSK)",
         'sub-head':'Improve the employability of students by offering Training, Counselling, and Opportunities.',
         'pic':naan_mudhalvan,
         'content_1':'',
         'content_2':'',
         'butt_text':'viewpdf',
         'pdflink':'https://drive.google.com/file/d/1F6WgHtbMQI_4OKZwSjply4Rf8hl1kGIr/view?usp=sharing',

     },
      {
         'id':'5',
         'heading':"3D Modelling Workshop Organized by ISTE Student's Chapter",
         'sub-head':'Enhancing the students practical knowledge in modern design and modelling tools ',
         'pic':iste_3d,
         'content_1':'',
         'content_2':'',
         'butt_text':'viewpdf',
         'pdflink':'https://drive.google.com/file/d/1ikHF7RjUj4Y6SV76MLS6_iyjBqCOYVY_/view?usp=drivesdk',

     },
     {
         'id':'5',
         'heading':"Pongal Celebration -2026",
         'sub-head':'Pongal Celebration – 2026 was joyfully celebrated at ACGCET bringing together students and staff in the spirit of tradition and unity.',
         'pic':pongal,
         'content_1':'',
         'content_2':'',
         //'butt_text':'viewpdf',
         //'pdflink':'https://drive.google.com/file/d/1F6WgHtbMQI_4OKZwSjply4Rf8hl1kGIr/view?usp=sharing',

     },
     {
         'id':'6',
         'heading':"Free Laptop Distribution Ceremony For Students (உலகம் உங்கள் கையில்)",
         'sub-head':'The Free Laptop Distribution Ceremony was held at the Seminar Hall, CSE Department, ACGCET.',
         'pic':laptop,
         'content_1':'',
         'content_2':'',
         //'butt_text':'viewpdf',
         //'pdflink':'https://drive.google.com/file/d/1F6WgHtbMQI_4OKZwSjply4Rf8hl1kGIr/view?usp=sharing',

     },
    // {
    //     'id':'9',
    //     'heading':"Tarcin MOU",
    //     'sub-head':'Memorandum of Understanding between ACGCET, Karaikudi and Garuda Aerospace Pvt.ltd, Chennai.',
    //     'pic':garuda,
    //     'content_1':'',
    //     'content_2':'',
    //     'butt_text':'viewpdf',
    //     'pdflink':'https://drive.google.com/file/d/11LFsCN6pOHrvZbtWlwkq12rl8sz8G_Ce/view?usp=sharing',

    // },
    // {
    //     'id':'8',
    //     'heading':"Tarcin Signature",
    //     'sub-head':'Memorandum of understanding is earned between Tarcin Robotic LLP, Madurai and ACGCET.',
    //     'pic':tarcinsign,
    //     'content_1':'',
    //     'content_2':'',
    //     'butt_text':'viewpdf',
    //     'pdflink':'https://drive.google.com/file/d/1aYah80F6D942XSe_jhtJNBbgULft3iKD/view?usp=sharing',
    // },
   // {
     //   'id': '11',
   //     'heading': "A Report on Karaikudi Startup Meetup – 20 Dec 2025 at Alagappa Incubation Forum, Karaikudi",
     //   'sub-head': '',
      //  'pic': startup_meetup,
       // pdflink :"https://alumni.accetosa.org/newsroom/news/A-Report-on-Karaikudi-Startup-Meetup-20-Dec-2025-at-Alagappa-Incubation-Forum-Karaikudi.dz",
      //  'butt_text': 'viewpdf'       
    //},
     // {
    //    'id': '10',
    //    'heading': "Workshop on Framing Analytical Questions",
    //    'sub-head': '',
    //    'pic': framing_workshop,
    //    'content_1': "The workshop was formally inaugurated by Dr. M.P. Vijayakumar, I.A.S (Retd), Vice Chairman, Tamil Nadu State Council for Higher Education (TANSCHE).Dr.K.Baskaran, Principal distributed participation certificates to the faculty members at the end of the Workshop.",
    //    'content_2': "Faculty from all departments were provided department-wise training. The workshop concluded with a renewed commitment from the faculty to adopt analytical, learner-centred assessment practices and thereby contribute to improved learning outcomes and academic excellence.",
    //    'butt_text': 'knowmore',
    //},
    //{
    //    'id': '1',
    //    'heading': "Golden Jubilee celebrations 1975-1980 batch",
    //    'sub-head': '',
    //    'pic': "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/iqac/goldernjublee_3.webp",
    //     pdflink:"https://drive.google.com/file/d/1XVGItmnfgKgL9CEP_tQHzLLYIQzRJLls/view?usp=sharing",
    //    
        //'content_1': "The grand inauguration of ISTE Innoverse ’25 was held with great enthusiasm in the presence of our Principal Dr. K. Baskaran, HoDs, faculty members, and students.The ceremony included lamp lighting, a welcome address, and badge distribution to office bearers.Ms. Janani Kamatchi delivered a warm welcome address.Badges of honour were presented to office bearers and coordinators, and Secretary Mr. Vishnuraam highlighted key achievements in the annual report.",
        //'content_2': "Dr. C. Umarani and Dr. K. Baskaran delivered motivating addresses. Prizes for Innovation X’25 and Riddle Rush were awarded, followed by a video presentation and a vote of thanks.",
    //    'butt_text': 'viewpdf',
    //},
    //{
    //    'id': '2',
    //    'heading': "Diamond Jubilee Reunion Celebration 1960-1965 batch",
    //    'sub-head': '',
    //    'pic': "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/iqac/goldernjublee2.webp",
        
        //'content_1': '',
        //'content_2': 'A 3-member NBA committee visited our institution on 08-06-2024 to renew the NBA accreditation for Civil, Mechanical and EEE Departments.',
        //'butt_text': 'knowmore',
    //},

    //{
    //    'id': '3',
    
    //    'heading': "Innoverise-25 ",
    //    'sub-head': 'Illuminate wokshop E-Cell IIT Bombay & EDC ACGCET',
    //    'pic':"https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/iqac/illuminate4.webp",
        
        //'content_1': 'On January 27, 2024, Oracle Bangalore conducted an AI/ML orientation at our campus featuring hands-on sessions and industry insights.',
        //'content_2': 'The program included practical tutorials and career guidance, giving students concise exposure to AI/ML concepts and real-world applications.',
        //'butt_text': 'knowmore',
    //},

    // {
    //     'id':'3',
    //     'heading':"Envision Conference at IITMRP",
    //     'sub-head':"Empowering Tomorrow's Leaders: Insights from the Envision Energy Conference at IITMRP",
    //     'pic':envision,
    //     // 'content_1':'A set of nine 2nd year students of our college recently had the opportunity to attend a dynamic conference themed "Envision Energy Conference" at IITMRP, on the dates 4th and 5th January, 2024, through the build club, which is being a great source of immense opportunities for our students. The conference proved to be an enlightening experience, that brought together professionals from diverse fields to exchange insights and ideas. The keynote sessions were particularly captivating, featuring industrial and educational delegates who shared their captivating and futuristic ideas. The interactive panel discussions were a highlight, allowing experts to engage in thought-provoking conversations. This groundbreaking conference not only provided valuable exposure to visionary ideas but also served as a platform for our students to broaden their understanding of the dynamic world around them',
    //     'content_2':'A set of nine 2nd year students of our college recently had the opportunity to attend a dynamic conference themed "Envision Energy Conference" at IITMRP, on the dates 4th and 5th January, 2024, through the build club, which is being a great source of immense opportunities for our students. The conference proved to be an enlightening experience, that brought together professionals from diverse fields to exchange insights and ideas. The keynote sessions were particularly captivating, featuring industrial and educational delegates who shared their captivating and futuristic ideas. The interactive panel discussions were a highlight, allowing experts to engage in thought-provoking conversations. This groundbreaking conference not only provided valuable exposure to visionary ideas but also served as a platform for our students to broaden their understanding of the dynamic world around them.',
    //     'butt_text':'knowmore',
    // },
    //{
        //'id': '4',
    
        //'heading': "Blood Donation Camp-2025 ",
        //'sub-head': '',
        //'pic ': "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/iqac/blooddt3.webp",
        
        //'content_1': 'From our college , 5 students of mechanical engineering and 1 student of Electrical and Electronics Engineering ,3 rd years  won   prize in Smart India hackathon hardware edition 2023 conducted at  Nalla malla Reddy Engineering College , Hyderabad  from dec 19 to 23 ,2023 .',
        //'content_2': 'The 14.6 km long cable belt conveyor is supported on pulleys. A steel rope runs over these pulleys while the belt sits over them. The conveyor is operated by pulling the steel ropes with a drive motor. The rope gets elongated due to pulling force leading to breakage of its strands. Similarly, the belt also gets worn out causing stoppage of conveyor operation unpredictably. Solution Desired: By capturing the past reasons for wear and tear including visuals and using a suitable ML application, try to predict the condition of the Rope and belt well in advance such that corrective and preventive actions can be taken before its failure preventing loss of production.',
        //'butt_text': 'knowmore',
    //},
    // {
    //     'id':'5',
    //     'heading':"General Aptitude Training",
    //     'sub-head':'Specialized weekend aptitude program for 60 third year students for academic & career success.',
    //     'pic':ga,
    //     'content_1':'',
    //     'content_2':"Commencing on the 9th of September, a specialized general aptitude training program has been organized for 60 third-year students over the weekends. Taking place on both Saturdays and Sundays, this initiative seeks to nurture the students' problem-solving skills and overall aptitude. By dedicating their weekends to this training, participants are preparing themselves for a competitive edge in their academic pursuits and future career endeavors. This comprehensive program is designed to instill valuable knowledge and capabilities, enabling these students to excel academically and navigate the complexities of the professional world with confidence. It serves as a valuable investment in their personal and intellectual growth."
    // },
    // {
    //     'id':'5',
    //     'heading':"World Standards Day, 2023",
    //     'sub-head':'Join us for an exhilarating journey of learning, unlearning and relearning on 09-10-2023.',
    //     'pic':stnd_day,
    //     'content_1':'Alagappa Chettiar Government College of Engineering and Technology, Sivaganga, hosts diverse events: writing, essay competitions, quizzes, debates, and nukkad natak. Winners eagerly await felicitation on World Standards Day in Madurai, a celebration of academic excellence and achievement.',
    //     'content_2':"A shared vision for a better world embodies the collective aspirations of individuals, communities, and nations to create a more equitable, sustainable, and harmonious global society. It is a beacon of hope that unites people across diverse backgrounds, inspiring collaboration and action. This vision encompasses ideals such as social justice, environmental stewardship, and peace, fostering a sense of responsibility to leave a lasting positive impact for future generations. It is a powerful force that drives humanity toward a brighter and more inclusive future."
    // },

    // {
    //     'id':'6',
    //     'heading':"Blood Donation Camp-2025",
    //    'sub-head':"The event witnessed active student participation.",
    //    'pic':"https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/iqac/blooddt3.webp",
    //    'content_1':'',
    //     'content_2':"The 3rd year students of our college attended a program called the Neuro- Linguistic Programming for three weeks on weekends from August 18,2023 to September 2,2023. This program consisted six engaging sessions and is related to communication and personality development. Our Alumni of 1998 batch sponsored for this program. A set of 32 students attended the program which was referred to as the 'Pilot Batch'. The students were greatly benefited by this program and a big thanks to our Alumni for arranging such a productive program for the students."
    //},

    //{
    //    'id': '7',
    //    'heading': "CENCON-25 ",
     //   'sub-head': "Inter Collegiate Technical Symposium Civil",
    //    'pic': 'https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/iqac/civilsympo0.webp',
        //'content_1': 'The IIT Madras Incubation Cell organized the "BUILD to INNOVATE" CHALLENGE (First Edition) for students in its partner institutes. This first edition featured challenges in the "Rural-Agri" space, providing a platform to introduce college students to innovating and building technology solutions for real-world problems, focusing on indigenous solutions for local challenges.',
        //'content_2': 'In this regard, our students (7 teams) participated in the preliminary round, and out of these, 3 teams were selected for the semi-finals, which took place at Thiagarajar College of Engineering, Madurai, on April 18, 2024. Following that, the Build Club of ACGCET hosted a Projects Demonstration Program as part of the "BUILD to INNOVATE CHALLENGE" on May 2, 2024, at the Corrosion Lab in Civil Engineering. First-year and second-year students attended the demonstration.',
        //'butt_text': 'knowmore',

    //},

    //{
    //    'id': '8',
    //    'heading': "Alconesy-25  ",
     //   'sub-head': "Inter Collegiate Technical Symposium EEE ",
    //    'pic':"https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/iqac/eee+sympo1.webp" ,
        //'content_1': 'BuildClub organized a Line Follower Robot Workshop to equip students with hands-on knowledge of autonomous robotics.This session provided participants with insights into sensor integration, motor control, and algorithm implementation, helping them understand the fundamentals of line-following robots.',
        //'content_2': 'Held on 20.02.25, the workshop served as a foundation for students who participated in Nexora on 27.02.25, enhancing their skills and confidence in tackling the Line Follower Robot Challenge.',
        //'butt_text': 'knowmore',
    //},
    //{
     //   'id': '9',
     //   'heading': "Inauguration of Fresher's Association",
     //   'sub-head': 'Fresher’s Association warmly welcomed the first-year students.',
     //   'pic':  "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/iqac/fresherrs4.webp" ,
     //   pdflink:"https://drive.google.com/file/d/1bGJYlly8DLCxstfBWusbv6_ntMkBSktu/view?usp=sharing",
        
        //'content_1': "",
        //'content_2': 'The keynote sessions were particularly captivating, featuring industrial and educational delegates who shared their captivating and futuristic ideas. The interactive panel discussions were a highlight, allowing experts to engage in thought-provoking conversations. This groundbreaking conference not only provided valuable exposure to visionary ideas but also served as a platform for our students to broaden their understanding of the dynamic world around them.',
     //   'butt_text': 'viewpdf',

    //}
   // {
     //   'id': '10',
       // 'heading': "Innoverse-25  ",
        //'sub-head': 'ISTE Students Chapter (TN 156)',
       // 'pic':"https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/iqac/iste1.webp",
        
        //'content_1': "Nexora brought together budding engineers and tech enthusiasts from first to third year, with nearly 40 teams competing in three distinct challenges that showcased their diverse skills and creativity.Element Explorer: A challenge in identifying and integrating missing elements to enhance analytical skills.\n" +
        //"Ohm-Code-Oku: A Sudoku-inspired puzzle testing logical reasoning and interdisciplinary knowledge.\n" +
        //"Line Follower Robot Challenge: Teams built and programmed robots to navigate a course using predefined paths.\n",
        //'content_2': 'Held on 27.02.25 from 2:00 PM to 5:00 PM, Nexora was not just a competition—it was a vibrant platform for collaboration, learning, and innovation. The event has set a high standard for future BuildClub initiatives and continues to inspire students to explore the limitless possibilities of technology.',
        //'butt_text': 'knowmore',
        
   // }
]